import { render } from "./VirtueShare.vue?vue&type=template&id=0ebd242d"
const script = {}
script.render = render

export default script